<template>
  <v-row class="px-4">
    <v-row class="px-2">
      <v-col class="text-center font-weight-bold">
        Статистика по приёму писем  от юридических лиц на период с
        <template>
          {{ startFilterDisplayValue }}
        </template>
        по
        <template>
          {{ endFilterDisplayValue }}
        </template>
      </v-col>
    </v-row>
    <v-row class="px-2">
      <v-col cols="12" sm="2"  md="2" class="d-flex align-center justify-center justify-md-end d-print-none">
        <v-select v-model="filters.type"
                  :items="typeOptions"
                  label="Выбрать версию"

        />
      </v-col>
      <v-col cols="12" md="3" class="d-flex align-center justify-center justify-md-end d-print-none">
        <v-menu
            v-model="filterStartMenu"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
        >
          <template v-slot:activator="{on}">
            <v-text-field
                label="Начало пероида"
                v-model="startFilterDisplayValue"
                readonly

                v-on="on"
                flat
            />
          </template>
          <v-date-picker
              v-model="filters.start"
              @change="onFilterStartChanged"
              no-title
              scrollable
              locale="ru"
              first-day-of-week="1"
              :allowed-dates="(date) => {
                 if (this.allowedFullAccessToPeriod) {
                  return true
                }

                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7)&&
                date <= new Date().toISOString().substr(0, 10);
              }"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" class="d-flex align-center justify-center justify-md-end d-print-none">
        <v-menu
            v-model="filterEndMenu"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            :close-on-content-click="false"
        >
          <template v-slot:activator="{on}">
            <v-text-field
                label="Конец пероида"
                v-model="endFilterDisplayValue"

                readonly
                v-on="on"
                flat
            />
          </template>
          <v-date-picker
              v-model="filters.end"
              @change="onFilterEndChanged"
              no-title
              scrollable
              locale="ru"
              first-day-of-week="1"
              :allowed-dates="(date) => {
                if (this.allowedFullAccessToPeriod) {
                  return true
                }

                const currentDate = new Date();
                const lastMonth = new Date();
                lastMonth.setMonth(currentDate.getMonth() - -1);
                const secondToLastMonth = new Date();
                secondToLastMonth.setMonth(currentDate.getMonth() - 2);

                return date <= lastMonth.toISOString().substr(0, 7) &&
                date >= secondToLastMonth.toISOString().substr(0, 7) &&
                date <= new Date().toISOString().substr(0, 10);
              }"
          />
        </v-menu>
      </v-col>
      <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-end d-print-none">
        <v-btn @click="onRefreshClicked" color="primary me-2" large :disabled="disableRefreshButton" >Обновить</v-btn>
        <v-btn @click="onPrintClicked" color="primary" large>Распечатать</v-btn>
      </v-col>
      <v-col cols="12">
        <template>
          <table>
            <thead>
            <tr style="background-color: aliceblue;">
              <th rowspan="2" class="filter-header" @click="toggleClients()">Организация</th>
              <th rowspan="2" class="text-center filter-header">Принято за период</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(2)" class="text-center filter-header">Распечатано за период из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(3)" class="text-center filter-header">Остаток к концу периода из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(4)" class="text-center filter-header">Досылов за период из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(5)" class="text-center filter-header">Сформировано за период из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(6)" class="text-center filter-header">Вручено из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(7)" class="text-center filter-header">Возврат из принятых</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(11)}" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(11)" class="text-center filter-header">Попытка вручения</th>
              <th rowspan="2" :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }" @click="toggleFilter(8)" class="text-center filter-header">Нет результата из принятых</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in validItems" :key="item.client.name">
              <v-btn :class="{ 'd-print-none': !filters.selectedClients.includes(item.client.id) }"  :style="{ backgroundColor: filters.selectedClients.includes(item.client.id) ? 'aliceblue' : '#e5e5e5' }" @click="toggleClient(item.client.id)" class="d-flex justify-space-between" style="height: 40px; width: 100%; background-color: aliceblue; border: 1px solid black; text-align: center">
                {{ item.client.name}}
              </v-btn>
              <td :class="{ 'd-print-none': !filters.selectedClients.includes(item.client.id), 'column': filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedClients.includes(item.client.id) ? '#e5e5e5' : '' }" @click="itemClicked(1, item.client.id, item.received)">{{ filters.selectedClients.includes(item.client.id) ? (item.received ? item.received : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2), 'column': filters.selectedFilters.includes(2) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(2) || !filters.selectedClients.includes(item.client.id) ? '#e5e5e5' : '' }" @click="itemClicked(2, item.client.id, item.printedForPeriodNormal)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(2) ? (item.printedForPeriodNormal ? item.printedForPeriodNormal : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3), 'column': filters.selectedFilters.includes(3) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(3) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(3, item.client.id, item.restForPeriodEnd)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(3) ? (item.restForPeriodEnd ? item.restForPeriodEnd : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4), 'column': filters.selectedFilters.includes(4) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(4) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(4, item.client.id, item.deletedFromPostPackageCount)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(4) ? (item.deletedFromPostPackageCount ? item.deletedFromPostPackageCount : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5), 'column': filters.selectedFilters.includes(5) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(5) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(5, item.client.id, item.postPackedForPeriod)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(5) ? (item.postPackedForPeriod ? item.postPackedForPeriod : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6), 'column': filters.selectedFilters.includes(6) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(6) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(6, item.client.id, item.deliveredFromPacked)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(6) ? (item.deliveredFromPacked ? item.deliveredFromPacked : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7), 'column': filters.selectedFilters.includes(7) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(7) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(7, item.client.id, item.returnedFromPacked)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(7) ? (item.returnedFromPacked ? item.returnedFromPacked : 0) : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11), 'column': filters.selectedFilters.includes(11) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(11) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(11, item.client.id, item.tryPerform)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(11) ? item.tryPerform : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8), 'column': filters.selectedFilters.includes(8) && filters.selectedClients.includes(item.client.id) }" :style="{ backgroundColor: !filters.selectedFilters.includes(8) || !filters.selectedClients.includes(item.client.id)  ? '#e5e5e5' : '' }" @click="itemClicked(8, item.client.id, item.postPackedNotPerformed)">{{ filters.selectedClients.includes(item.client.id) && filters.selectedFilters.includes(8) ? (item.postPackedNotPerformed ? item.postPackedNotPerformed : 0) : null }}</td>
            </tr>
            <tr style="background-color: aliceblue; color: black; font-weight: bold">
              <td style="height: 40px; text-align: center">Общее</td>
              <td>{{ totals.received }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(2) }" :style="{ backgroundColor: filters.selectedFilters.includes(2) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(2) ? totals.printedForPeriodNormal : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(3) }" :style="{ backgroundColor: filters.selectedFilters.includes(3) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(3) ? totals.restForPeriodEnd : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(4) }" :style="{ backgroundColor: filters.selectedFilters.includes(4) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(4) ? totals.deletedFromPostPackageCount : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(5) }" :style="{ backgroundColor: filters.selectedFilters.includes(5) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(5) ? totals.postPackedForPeriod : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(6) }" :style="{ backgroundColor: filters.selectedFilters.includes(6) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(6) ? totals.deliveredFromPacked : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(7) }" :style="{ backgroundColor: filters.selectedFilters.includes(7) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(7) ? totals.returnedFromPacked : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(11) }" :style="{ backgroundColor: filters.selectedFilters.includes(11) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(11) ? totals.tryPerform : null }}</td>
              <td :class="{ 'd-print-none': !filters.selectedFilters.includes(8) }" :style="{ backgroundColor: filters.selectedFilters.includes(8) ? 'aliceblue' : '#e5e5e5' }">{{ filters.selectedFilters.includes(8) ? totals.postPackedNotPerformed : null }}</td>
            </tr>
            </tbody>
          </table>
          <v-dialog v-model="showModal" :persistent="true" width="1000px">
            <ClientMailsModal ref="clientMailsModal" @close-modal="closeModal"/>
          </v-dialog>
        </template>
      </v-col>
    </v-row>
    <v-snackbar
        v-if="disableRefreshButton"
        :timeout="-1"
        :value="true"
        absolute
        bottom
        color="red"
        right
    >
      Дату можно выбрать в пределах одного месяца
    </v-snackbar>
  </v-row>
</template>

<script>
import Moment from 'moment'
import _ from "underscore";
import {required} from 'vuelidate/lib/validators'
import {DateLimitForFilters} from "@/settings/server";
import ClientMailsModal
  from "@/components/report/ClientStatistics/Modals/ClientMailsModalComponent.vue";

export default {
  name: "ClientsReport",
  components: {ClientMailsModal},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        start: null,
        end: null,
        date: null,
        selectedFilters: [],
        selectedClients: [],
        type: 1
      },
      showModal: false,
      typeOptions: [
        { text: '1', value: 1 },
      ],
      startFilterDisplayValue: null,
      endFilterDisplayValue: null,
      dateFilterDisplayValue: null,
      filterStartMenu: false,
      filterEndMenu: false,
      filterDateMenu: false,
    }
  },
  computed: {
    // New computed property to filter out malformed objects safely
    validItems() {
      return this.items.filter(item => item && item.client && item.client.name && item.client.id);
    },
    totals() {
      let received = 0;
      let printedForPeriodNormal = null;
      let restForPeriodEnd = null;
      let deletedFromPostPackageCount = null;
      let postPackedForPeriod = null;
      let deliveredFromPacked = null;
      let returnedFromPacked = null;
      let postPackedNotPerformed = null;
      let tryPerform = null;

      // Updated to iterate over validItems instead of raw items
      _.each(this.validItems, item => {
        received += (item.received || 0);
        if(item.printedForPeriodNormal !== null && item.printedForPeriodNormal !== undefined)
          printedForPeriodNormal += item.printedForPeriodNormal
        if(item.restForPeriodEnd !== null && item.restForPeriodEnd !== undefined)
          restForPeriodEnd += item.restForPeriodEnd
        if(item.tryPerform !== null && item.tryPerform !== undefined)
          tryPerform += item.tryPerform
        if(item.deletedFromPostPackageCount !== null && item.deletedFromPostPackageCount !== undefined)
          deletedFromPostPackageCount += item.deletedFromPostPackageCount
        if(item.postPackedForPeriod !== null && item.postPackedForPeriod !== undefined)
          postPackedForPeriod += item.postPackedForPeriod
        if(item.deliveredFromPacked !== null && item.deliveredFromPacked !== undefined)
          deliveredFromPacked += item.deliveredFromPacked
        if(item.returnedFromPacked !== null && item.returnedFromPacked !== undefined)
          returnedFromPacked += item.returnedFromPacked
        if(item.postPackedNotPerformed !== null && item.postPackedNotPerformed !== undefined)
          postPackedNotPerformed += item.postPackedNotPerformed
      });

      return {
        received: received,
        printedForPeriodNormal: printedForPeriodNormal,
        restForPeriodEnd: restForPeriodEnd,
        deletedFromPostPackageCount: deletedFromPostPackageCount,
        postPackedForPeriod: postPackedForPeriod,
        deliveredFromPacked: deliveredFromPacked,
        tryPerform: tryPerform,
        returnedFromPacked: returnedFromPacked,
        postPackedNotPerformed: postPackedNotPerformed,
      }
    },
    disableRefreshButton() {
      if (this.allowedFullAccessToPeriod === true) {
        return false
      }

      return this.isAllowedReload() || this.$v.$invalid
    },
    allowedFullAccessToPeriod() {
      const allowedUserIds = [1,10,11,30,44,45,67,225,227,262,931,1009,1027,1554,1722,2158,2196,17480,18260];

      if (allowedUserIds.includes(this.$store.getters.appLogin.id)) {
        return true;
      }
      return false;
    }
  },
  validations: {
    filters: {
      start: {
        required
      },
      end: {
        required
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    itemClicked(filter, client, count){
      if(filter && client && count){
        this.showModal = true;

        this.$nextTick(() => {
          this.$refs.clientMailsModal.set(filter, client, this.filters, count, "Статистика клиентов");
        });
      }
    },
    toggleClients(){
      if(this.filters.selectedClients.length === 0){
        // Updated to iterate over validItems to prevent crashing here too
        for (const item of this.validItems) {
          this.filters.selectedClients.push(item.client.id)
        }
      }
      else {
        this.filters.selectedClients = []
      }
    },
    toggleFilter(filterId) {
      const index = this.filters.selectedFilters.findIndex(id => id === filterId);
      if (index !== -1) {
        this.filters.selectedFilters.splice(index, 1);
      } else {
        this.filters.selectedFilters.push(filterId);
      }
    },
    toggleClient(clientId) {
      const index = this.filters.selectedClients.findIndex(item => item === clientId);
      if (index !== -1) {
        this.filters.selectedClients.splice(index, 1);
      } else {
        this.filters.selectedClients.push(clientId);
      }
    },
    isAllowedReload() {
      const startDate = this.filters.start;
      const endDate = this.filters.end;

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const dayDifference = (end - start) / (1000 * 60 * 60 * 24);

        if (dayDifference > DateLimitForFilters) {
          return true;
        }
      }
    },
    updateItems() {
      this.$emit('updated', this.filters)
    },
    onRefreshClicked() {
      this.updateItems()
    },
    onFilterStartChanged() {
      if (this.filters.start) {
        this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterStartMenu = false
    },
    onFilterEndChanged() {
      if (this.filters.end) {
        this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }

      this.filterEndMenu = false
    },

    onFilterDateChanged() {
      if (this.filters.date) {
        this.dateFilterDisplayValue = Moment(this.filters.date, 'YYYY-MM').format('MM.YYYY')
      }

      this.filterDateMenu = false
    },

    onPrintClicked() {
      window.print()
    }
  },
  created() {
    this.filters.start = Moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.filters.end = Moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.filters.selectedClients.push(this.$store.getters.appActiveClient.id)

    this.startFilterDisplayValue = Moment(this.filters.start, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.endFilterDisplayValue = Moment(this.filters.end, 'YYYY-MM-DD').format('DD.MM.YYYY')
    this.updateItems()
  }
}
</script>

<style scoped>
.filter-header {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.filter-header:hover{
  background-color: #dfe7ed;
}


.column {
  padding: 5px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
}

.column:hover{
  background-color: #dfe7ed;
}

th {
  text-align: center;
  border-right: 2px solid black;
  border-bottom: 2px solid black !important;
}

tr th:first-child {
  border-left: 2px solid black;
}

tr:nth-child(2) th:first-child {
  border-left: 0;
}

tr:first-child th {
  border-top: 2px solid black;
}

td {
  text-align: center;
  border-right: 1px solid #253d6d;
  border-bottom: 1px solid #253d6d;
}

td:first-child {
  text-align: left;
  border-left: 1px solid #253d6d;
}

@media print {
  td, th {
    padding: 0 5px !important;
    margin: 0 !important;
  }

  table {
    page-break-inside: auto
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto
  }
}
</style>